import { RESET, SET_SCHEDULE_STATE } from "./scheduleStateFilter.actionTypes";

export const reset = () => (dispatch) => {
  dispatch({
    type: RESET,
  });
};

export const setScheduleState = (data) => (dispatch) => {
  dispatch({
    type: SET_SCHEDULE_STATE,
    payload: data,
  });
};
